import React, { useState } from "react";
import NCS from "../assets/NCS.png";
import AOP from "../assets/Adoptapet.jpg";
import LV from "../assets/Letsvote.jpg";
import FM from "../assets/Facemask.jpg";
import Xray from "../assets/Xray.png";
import SV from "../assets/Salvador.jpg";
import Blog from "../assets/Blog.png";
function Projects(props) {
  const [project, setProject] = useState(true);
  const projectData = [
    {
      id: 1,
      category: "ml",
      title: "News Classification and Summarization",
      description:
        "Developed a web application that classifies news in myriad number of classes and provides summarized news articles using deep learning models. The web-app was created using Flask and models such as Naive Bayes, LSTM & Text-Rank were developed. ",
      link: "https://github.com/Naivedh/NCS",
      image: NCS,
    },
    {
      id: 2,
      category: "ml",
      title: "Face Mask detection",
      description:
        "Trained MobileNetV2 model to detect whether a person is wearing a mask or not to avoid transmission of COVID-19. Transfer learning and Image augmentation techniques were used to obtain better results. Harcasscade was used to detect face. ",
      link: "https://github.com/Naivedh/Face-Mask-Detetction",
      image: FM,
    },
    {
      id: 3,
      category: "web",
      title: "Adopt A pet",
      description:
        "Built an app using React, Redux, and Firebase which allows users to adopt a pet as well as provide a pet for adoption.",
      link: "https://github.com/Naivedh/Adopt-A-Pet",
      image: AOP,
    },
    {
      id: 4,
      category: "web",
      title: "Let's vote",
      description:
        "Created an election Voting application using React.JS and Firebase with login and voting functionality.",
      link: "https://github.com/Naivedh/Let-s-Vote",
      image: LV,
    },
    {
      id: 5,
      category: "ml",
      title: "Digital Xray",
      description:
        "Developed a web app with Flask which allows users to test whether they are suffering from pneumonia/corona by uploading their X-ray images. Transfer learning and Image augmentation along with the MoileNet model were used to obtain better results. ",
      link: "https://github.com/Naivedh/DigitalXray",
      image: Xray,
    },
    {
      id: 6,
      category: "web",
      title: "Salvador",
      description:
        "Developed a Web-application to ensure the safety of women. It is build using HTML, CSS for frontend, PHP for backend, MySQL as database, Twitter API and Leaflet for maps.",
      link: "https://github.com/Naivedh/Salvador",
      image: SV,
    },
    {
      id: 7,
      category: "web",
      title: "Blog",
      description:
        "Created a blogging Website using Html, CSS, Bootstarp for frontend, PHP for backend and MySQL as database.",
      link: "https://github.com/Naivedh/PHP-BLOG/tree/master/WT",
      image: Blog,
    },
  ];

  const SingeleProject = (props) => {
    return (
      <div className="col-sm-12">
        <div className="row project__conatiner" key={props.data.id}>
          <div className="col-md-12 col-lg-6 project__container__img">
            <img src={props.data.image} alt="" />
          </div>
          <div className="col-md-12 col-lg-6">
            <p className="oneproject__title">{props.data.title}</p>
            <p style={{ textAlign: "justify" }}>{props.data.description}</p>
            <a rel="noreferrer" href={props.data.link} target="_blank">
              <button className="project__button">
                <div className="row">
                  <div className="col my-auto">
                    <span>Explore</span>
                  </div>
                  <div className="col">
                    <i className="icon mx-3 fab fa-2x fa-github"></i>
                  </div>
                </div>
              </button>
            </a>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div id="projects" className="projects" data-aos={"fade-left"}>
      <span className="project__span">Projects 💻</span>
      <div className="row projects__title">
        <div
          className={`col-sm-6 my-3 ${project ? "alive" : null}`}
          onClick={() => setProject(true)}
        >
          <span>Web Development</span>
        </div>
        <div
          className={`col-sm-6 my-3 ${!project ? "alive" : null}`}
          onClick={() => setProject(false)}
        >
          <span>Machine Learning</span>
        </div>
      </div>
      <div>
        <div className="container">
          {projectData.map((data) => {
            if (!project && data.category === "ml") {
              return <SingeleProject key={data.id} data={data} />;
            } else if (project && data.category === "web") {
              return <SingeleProject key={data.id} data={data} />;
            } else {
              return <div></div>;
            }
          })}
        </div>
      </div>
    </div>
  );
}

export default Projects;
